import React from "react";
import Header from "../common/header&footer/Header";
import Footer from "../common/header&footer/Footer";

export default function AboutUs() {
  return (
    <div className="flex flex-col min-h-screen">
      <main className="flex-grow">
        {/* Background Image Section */}
        <section
          className="bg-cover bg-center bg-no-repeat h-[50vh]"
          style={{
            backgroundImage: "url('/images/about-us.jpg')",
          }}
        ></section>

        {/* White Content Section */}
        <section className="bg-white py-16 relative z-10">
          <div className="-mt-64 bg-white w-[90%] max-w-[88rem] mx-auto p-16 grid grid-cols-1">
            {/* About TYKA */}
            <div className="lg:col-span-2">
              <p className="text-red-500 font-semibold mb-2">About TYKA</p>
              <h1 className="text-3xl md:text-4xl font-bold mb-4">
                IT ALL STARTED WITH AN IDEA
              </h1>
              <p className="text-gray-700 mb-4 leading-relaxed text-justify">
                Our visionary leader, Mr. Rajan Kohli (MD, TK Sports Private
                Limited) had a passion for sports and spirit of an entrepreneur.
                For years TK sports had produced Hockey / Cricket gear and it
                was in 2009 when TYKA apparel were started in a small room with
                4 machines and a mission.
              </p>
              <p className="text-gray-700 leading-relaxed text-justify">
                Though our beginning was small our aspirations were not. We
                aspired to become the best solutions provider for athletes who
                wanted to look good and perform better, for them to perform
                better we needed to put our best game forward, and that is what
                we did.
                <br />
                Just like a Cricket Test match we started building a strong
                foundation by focusing only and only on consumer satisfaction
                and quality. We kept leaving the deliveries outside the quality
                stump with patience and it paid off as the reputed National
                Indian Hockey - Men and women - Senior and Junior teams became
                one of our first clients followed by UP Cricket Association and
                Cricket Association of Bengal for the Ranji Trophy and Indian
                Shooting Team.
              </p>
              <h1 className="text-3xl md:text-4xl font-bold mt-8 mb-4">
                BECAME ONE OF THE TOP BRAND IN INDIA
              </h1>
              <p className="text-gray-700 mb-4 leading-relaxed text-justify">
                By 2012, we were well settled on the crease and our performance
                was making the top shots of the Indian and Global sporting
                fraternity take note of us. This was when one of the franchises
                of the Indian Premier League, Kings XI not only become our
                clients but so impressed were they with our quality they
                promoted us as well. What began as a Test match for us has today
                become a high octane T-20 Journey and we are not alone in it. We
                feel proud today to have served over 2500 plus teams/clubs
                across the globe.
              </p>
            </div>

            {/* Our Team Section */}
            <div className="w-full py-12">
              <div className="h-px bg-gray-300 mb-4"></div>
              <h2 className="text-sm text-gray-400 uppercase mb-6">Our Team</h2>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
                {/* Rajan Kohli */}
                <div>
                  <h3 className="text-2xl font-semibold mb-1">Rajann Kohli</h3>
                  <p className="text-lg text-gray-600 mb-4">
                    Managing Director
                  </p>
                  <p className="text-gray-700 mb-6 text-justify">
                    Our business began in 1985, as an idea of our founder. He
                    started by selling cricket bats while he was still studying.
                    Increasing popularity made him realize his capabilities and
                    pushed him to develop a company that employs hundreds of
                    enthusiasts today. He built our company into a leading
                    developer, marketer and distributor of branded performance
                    apparel and accessories. His keen interest in new projects
                    and innovation today lead us to one of the best in our
                    range.
                  </p>
                  <div className="max-w-4xl mx-auto">
                    <img
                      src="images/md.jpg"
                      alt="Rajan Kohli"
                      // className="w-full h-96 object-contain"
                    />
                  </div>
                </div>

                {/* Sonal Kohli */}
                <div>
                  <h3 className="text-2xl font-semibold mb-1">Sonnal Kohli</h3>
                  <p className="text-lg text-gray-600 mb-4">
                    Marketing & Design Head, Director
                  </p>
                  <p className="text-gray-700 mb-6 text-justify">
                    TYKA is obsessed with being better, stronger, and more
                    focused than anyone else out there. From product innovations
                    and campaigns to the partnerships and big bets that
                    propelled the Brand forward, these are the moments that made
                    us who we are. At TYKA, we’re a team of doers, striving to
                    be the best. We challenge convention, and we challenge each
                    other. We play to win. We share our triumphs, learn from our
                    mistakes, and always fight on together to be the best.
                  </p>
                  {/* <img 
                    src="images/mh.jpg" 
                    alt="Sonal Kohli" 
                    className="w-full h-96 object-contain"
                  /> */}
                  <div className="max-w-4xl mx-auto">
                    <img
                      src="images/mh.jpg"
                      alt="Rajan Kohli"
                      // className="h-96 object-contain"
                      style={{ height: "26rem" }}
                    />
                  </div>
                </div>
              </div>
            </div>

            {/* Our Mission */}
            <div className="lg:col-span-2">
              <h1 className="text-3xl md:text-4xl font-bold mb-4">
                Our Mission
              </h1>
              <p className="text-gray-700 mb-4 leading-relaxed text-justify">
                To Relentlessly push beyond all limits known in the development
                and design of performance apparel to make our athletes look good
                and perform better on and off the fields. We at TYKA truly
                believe that real improvement and innovation in performance gear
                never comes from known but from outside the boundaries of what
                already exists. Creators cannot be followers. TYKA is an
                attitude shared by every serious athlete who considers their
                personal best not as a benchmark but as an ever-new starting
                point for what’s infinitely and excitingly possible when you
                dare to step outside the limits of the known.
              </p>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
}
